import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { InlineEditTableColumnData } from "../../../../../types/inlineEditTable.types";
import type {
  PPAInvoiceNumberRange,
  PPAInvoiceSupplier
} from "../../PPAInvoiceNumberRangesPage.types";

export function getSupplierColumn(
  { validationErrors }: InlineEditTableColumnData,
  companies: Array<PPAInvoiceSupplier> | undefined
): MRT_ColumnDef<PPAInvoiceNumberRange> {
  const companyChoices = companies
    ? companies.map((company) => company.name).sort()
    : [];

  return {
    id: "supplier",
    accessorFn: (row) => {
      const supplierName = companies?.find(
        (company) => company.id === row.supplier_id
      )?.name;

      return supplierName ?? null;
    },
    header: "Rechnungssteller",
    editVariant: "select",
    enableSorting: false,
    mantineEditSelectProps: {
      "aria-label": "Rechnungssteller",
      data: companyChoices,
      error: validationErrors.supplier_id,
      placeholder: "Bitte auswählen",
      required: true
    },
    size: 300
  };
}
